import React, { useEffect, useState } from 'react';
import useDynamicRefs from 'use-dynamic-refs';
import { graphql, StaticQuery } from 'gatsby';
// import navIcon from '../../images/icon-navigation.svg';
// import navImage from '../../images/image-community.svg';
import { StaticImage } from 'gatsby-plugin-image';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import rightIcon from '../../images/arrow-pro-right.svg';
import LangSelector from './langSelector';

/** 
 * @param {*} propLink 
 * @returns Link Element with defined prop values
 */
const MenuLink = (propLink) => (
  <a href={`${propLink.url}`} target={propLink.target} className="l--flex">
    <span>
      {propLink.navicon &&
        // <GatsbyImage image={getImage(propLink.navicon.localFile)} alt={propLink.navicon.altText} />
        <img src={propLink.navicon.sourceUrl} alt={propLink.navicon.altText} />
      }
    </span>
    <span className="l--maxWidth">
      <span className={`l-navItemTitle ${propLink.classes || 'l-nodefinedClass'}`}>{propLink.title}</span>
      {propLink.description &&
        <span className="l-navItemDescription" dangerouslySetInnerHTML={{ __html: propLink.description }} />
      }
    </span>
  </a >
);

/**
 * @returns Fetches data via Graphql and outputs Main Navigation markup
 */
const MainMenu = ({ propss }) => {

  const [activeElement, setActiveElement] = useState(null);
  const [hamburgeractiveElement, hamburgersetActiveElement] = useState(null);
  // const [loader, setLoader] = useState(false);
  const [backgroundShow, SetbackgroundShow] = useState(false);
  const [getRef, setRef] = useDynamicRefs();
  let mediaQueryMax = null;
  let mediaQueryMin = null;
  let elemLoad = "elemtertiaryid-0";
  if (typeof window !== "undefined") {
    mediaQueryMax = window.matchMedia("(max-width: 980px)");
    mediaQueryMin = window.matchMedia("(min-width: 981px)");
    if (mediaQueryMin.matches) {
      elemLoad = "elemtertiaryid-0";
    }
    else {
      elemLoad = null;
    }
  }
  const [tertiaryActiveElement, setTertiaryActiveElement] = useState(elemLoad);

  const onClick = (index) => {
    if (getRef(index).current.previousElementSibling) {
      if (getRef(index).current.previousElementSibling.classList.contains('is-active')) {
        SetbackgroundShow(false);
      }
      else {
        SetbackgroundShow(true);
      }
    }
    setActiveElement(index);
    if (getRef(index).current) {
      if (getRef(index).current.previousElementSibling) {
        getRef(index).current.previousElementSibling.classList.toggle('is-active');
      }
      getRef(index).current.classList.toggle('is-active');
    }
    // {
    //   activeElement === "elemid-0" &&
    //     onTertiaryClick("elemtertiaryid-0");
    // }
    // setTimeout(() => {
    //   setLoader(false);
    // }, 4000);
  };

  const onTertiaryClick = (index) => {
    setTertiaryActiveElement(index);
    if (getRef(index).current) {
      getRef(index).current.classList.add('is-active');
    }
    if (mediaQueryMax.matches) {
      getRef(index).current.parentElement.nextElementSibling.classList.add('is-mobileClick');
      getRef(index).current.parentElement.classList.add('is-mobileClick');
    }
  };

  const onBackClick = (index) => {
    if (getRef(index).current) {
      getRef(index).current.classList.remove('is-mobileClick');
      getRef(index).current.previousElementSibling.classList.remove('is-mobileClick');
      setTertiaryActiveElement(null);
    }
  }

  const hamburgerClick = (index) => {
    hamburgersetActiveElement(index);
    if (getRef(index).current) {
      getRef(index).current.nextElementSibling.querySelector('.cp-booktoggle__hamburger').classList.toggle('is-active');
      getRef(index).current.classList.toggle('is-active');
    }
  };

  const closeNav = (val) => {
    setActiveElement(val)
    SetbackgroundShow(false);
  }

  useEffect(() => {

  }, [hamburgerClick, onClick])

  // const arrayPush = (menuItem, index) => {
  //   topNavList.splice(index, 0, menuItem);
  //   { counter++ }
  //   // topNavList = [menuItem, ...topNavList];
  // }

  // const onBlur = (index) => {
  //   // alert(index + 'yo ' + setActiveElement);
  //   if (index === setActiveElement) {
  //     getRef(index).current.classList.remove('is-active');
  //   }
  // }

  // useEffect(() => {
  //   // alert('yes');
  //   const pageClickEvent = (e) => {
  //     setIsActive(!isActive);
  //   };

  //   if (isActive) {
  //     window.addEventListener('click', pageClickEvent);
  //   }

  //   return () => {
  //     window.removeEventListener('click', pageClickEvent);
  //   }

  // }, [isActive]);

  return (
    <StaticQuery query={graphql`
    {
      allWordpress {
        nodes {
          themeSettings {
            navigationElements {
              subNav1Header
              subNav1Link {
                url
                title
                target
              }
              subNav1CustomerStories {
                ... on WordpressCustomerstory {
                  id
                  title
                  excerpt
                  uri
                  slug
                  featuredImage {
                    node {
                      altText
                      sourceUrl
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                }
                ... on WordpressResource {
                  id
                  title
                  excerpt
                  uri
                  slug
                  featuredImage {
                    node {
                      altText
                      sourceUrl
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                }
                ... on WordpressEvent {
                  id
                  title
                  excerpt
                  uri
                  slug
                  featuredImage {
                    node {
                      altText
                      sourceUrl
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                }
              }
              subNav1BackgroundColor
              subNavElement2Image {
                altText
                sourceUrl
                gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
              }
              subNavElement2Title
              subNavElement2Teaser
              subNav2BackgroundColor
              subNav2DropdownLink {
                target
                title
                url
              }
              newNavigationCustomerStories {
                backgroundColor
                title
                teaser
                link {
                  target
                  title
                  url
                }
                image {
                  altText
                  gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                }
              }
              addElementNumbers{
                elementId
              }
            }
          }
        }
      }
      allWordpressMenuItem(filter: {menu: {node: {name: {eq: "Main menu"}}}}) {
        edges {
          node {
            label
            url
            description
            cssClasses
            parentId
            navigationIconsAndImages {
              icon {
                altText
                sourceUrl
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
              image {
                altText
                sourceUrl
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
            childItems {
              nodes {
                cssClasses
                url
                label
                description
                navigationIconsAndImages {
                  icon {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                  image {
                    altText
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                }
                childItems {
                  nodes {
                    cssClasses
                    url
                    label
                    description
                    navigationIconsAndImages {
                      icon {
                        altText
                        sourceUrl
                        localFile {
                          childImageSharp {
                            gatsbyImageData
                          }
                        }
                      }
                      image {
                        altText
                        localFile {
                          childImageSharp {
                            gatsbyImageData
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }                             
    `} render={props => (
        <>
          {backgroundShow &&
            <button onClick={() => closeNav(null)} className="l-navigationBackground"></button>
          }
          <nav ref={setRef('hamburgerOpen')} className={`cp-mainNav ${hamburgeractiveElement === 'hamburgerOpen' ? 'is-active' : 'inactive'}`}>
            <ul className="cp-mainNav__primary l--flex">
              {props.allWordpressMenuItem.edges.map((menuItem, index) => (
                <React.Fragment key={index}>
                  {menuItem.node.parentId === null &&
                    <li className={menuItem.node.childItems.nodes.length ? 'l-hasChild' : 'l-noChild'}>
                      {menuItem.node.childItems.nodes.length ?
                        <button onClick={() => onClick(`elemid-${index}`)} className={`${menuItem.node.cssClasses} ${activeElement === `elemid-${index}` ? 'is-active' : 'inactive'}`} >{menuItem.node.label}</button>
                        :
                        <a href={`${menuItem.node.url}`} className="l--flex" >{menuItem.node.label}</a>
                      }
                      {menuItem.node.childItems &&
                        <div ref={setRef(`elemid-${index}`)} className={`cp-mainNav__primary-wrapper js-toggle l--flex ${activeElement === `elemid-${index}` ? 'is-active' : 'inactive'}`}>
                          <div className="cp-mainNav__primary-wrapper-left">

                            {menuItem.node.childItems.nodes.map((checkTertiary, index) => (
                              <React.Fragment key={index}>
                                {index === 0 &&
                                  <>
                                    {
                                      checkTertiary.childItems.nodes.length ?
                                        /* Layout 1 if tertiary nav is available */
                                        <div className="cp-mainNav__secondary l--flex">
                                          <div className="cp-mainNav__secondary-right">
                                            {menuItem.node.childItems.nodes.map((subNavItem, index) => (
                                              <ul key={index} ref={setRef(`elemtertiaryid-${index}`)} className={`${tertiaryActiveElement === `elemtertiaryid-${index}` ? 'is-active' : 'inactive'}`}>
                                                <button className="l-title l-mobileOnly" onClick={() => onBackClick("mobileBackTrigger")}>
                                                  <StaticImage src="../../images/arrow-left.svg" alt="" />
                                                  <span dangerouslySetInnerHTML={{ __html: subNavItem.label }} />
                                                </button>
                                                <li>
                                                  {subNavItem.childItems &&
                                                    <ul className="cp-mainNav_tertiary l--flex">
                                                      {subNavItem.childItems.nodes.map((tertiaryNavItems, index) => (
                                                        <li key={index}>
                                                          <MenuLink navicon={tertiaryNavItems.navigationIconsAndImages.icon} description={tertiaryNavItems.description} url={tertiaryNavItems.url} classes={tertiaryNavItems.cssClasses} title={tertiaryNavItems.label} />
                                                        </li>
                                                      ))}
                                                    </ul>
                                                  }
                                                </li>
                                              </ul>
                                            ))}
                                          </div>
                                          <ul className="cp-mainNav__secondary-left" ref={setRef('mobileBackTrigger')}>
                                            {menuItem.node.childItems.nodes.map((subNavItem, index) => (
                                              <React.Fragment key={index}>
                                                <li>
                                                  <button onClick={() => onTertiaryClick(`elemtertiaryid-${index}`)} className={`${tertiaryActiveElement === `elemtertiaryid-${index}` ? 'is-active' : 'inactive'}`} >
                                                    <span className="l-title" dangerouslySetInnerHTML={{ __html: subNavItem.label }} />
                                                    <span className="l-desc" dangerouslySetInnerHTML={{ __html: subNavItem.description }} />
                                                    <StaticImage src="../../images/nav-arrow-right.svg" alt="" />
                                                  </button>
                                                </li>
                                              </React.Fragment>
                                            ))}
                                          </ul>
                                        </div>
                                        /* Layout 1 if tertiary nav is available */
                                        :
                                        /* Layout 2 if tertiary nav is not available */
                                        <div className="cp-mainNav__secondary l--flex">
                                          <ul className="l--flex l-layoutGeneric">
                                            {menuItem.node.childItems.nodes.map((subNavItem, index) => (
                                              <li key={index} className={`${subNavItem.cssClasses || 'l-nodefinedClass'}`}>
                                                <MenuLink navicon={subNavItem.navigationIconsAndImages.icon} description={subNavItem.description} url={subNavItem.url} classes={subNavItem.cssClasses} title={subNavItem.label} />
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                      /* Layout 2 if tertiary nav is not available */
                                    }
                                  </>
                                }
                              </React.Fragment>
                            ))}
                          </div>
                          <div className={`cp-mainNav__primary-wrapper-right ${activeElement === "elemid-0" && tertiaryActiveElement === "elemtertiaryid-2" ? 'l--two' : ''}`} style={{ backgroundColor: props.allWordpress.nodes[0].themeSettings.navigationElements.subNav1BackgroundColor }}>
                            {activeElement === "elemid-0" &&
                              <>
                                {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories &&
                                  <>
                                    <div className="l--navElement" key={index} style={{ backgroundColor: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].backgroundColor }}>
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].title &&
                                        <h3 dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].title }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].teaser &&
                                        <p dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].teaser }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].image &&
                                        <GatsbyImage image={getImage(props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].image.gatsbyImage)} alt={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].image.altText} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].link &&
                                        <a href={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].link.url} target={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].link.target}>
                                          <span>{props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[0].link.title}</span>
                                          <img src={rightIcon} alt="" />
                                        </a>
                                      }
                                    </div>
                                  </>
                                }
                              </>
                            }
                            {activeElement === `elemid-${props.allWordpress.nodes[0].themeSettings.navigationElements.addElementNumbers[1].elementId}` &&
                              <>
                                {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories &&
                                  <>
                                    <div className="l--navElement" key={index} style={{ backgroundColor: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].backgroundColor }}>
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].title &&
                                        <h3 dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].title }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].teaser &&
                                        <p dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].teaser }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].image &&
                                        <GatsbyImage image={getImage(props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].image.gatsbyImage)} alt={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].image.altText} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].link &&
                                        <a href={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].link.url} target={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].link.target}>
                                          <span>{props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[1].link.title}</span>
                                          <img src={rightIcon} alt="" />
                                        </a>
                                      }
                                    </div>
                                  </>
                                }
                              </>
                            }
                            {activeElement === `elemid-${props.allWordpress.nodes[0].themeSettings.navigationElements.addElementNumbers[2].elementId}` &&
                              <>
                                {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories &&
                                  <>
                                    <div className="l--navElement" key={index} style={{ backgroundColor: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].backgroundColor }}>
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].title &&
                                        <h3 dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].title }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].teaser &&
                                        <p dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].teaser }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].image &&
                                        <GatsbyImage image={getImage(props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].image.gatsbyImage)} alt={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].image.altText} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].link &&
                                        <a href={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].link.url} target={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].link.target}>
                                          <span>{props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[2].link.title}</span>
                                          <img src={rightIcon} alt="" />
                                        </a>
                                      }
                                    </div>
                                  </>
                                }
                              </>
                            }
                            {activeElement === `elemid-${props.allWordpress.nodes[0].themeSettings.navigationElements.addElementNumbers[3].elementId}` &&
                              <>
                                {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories &&
                                  <>
                                    <div className="l--navElement" key={index} style={{ backgroundColor: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].backgroundColor }}>
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].title &&
                                        <h3 dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].title }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].teaser &&
                                        <p dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].teaser }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].image &&
                                        <GatsbyImage image={getImage(props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].image.gatsbyImage)} alt={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].image.altText} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].link &&
                                        <a href={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].link.url} target={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].link.target}>
                                          <span>{props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[3].link.title}</span>
                                          <img src={rightIcon} alt="" />
                                        </a>
                                      }
                                    </div>
                                  </>
                                }
                              </>
                            }
                            {activeElement === `elemid-${props.allWordpress.nodes[0].themeSettings.navigationElements.addElementNumbers[4].elementId}` &&
                              <>
                                {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories &&
                                  <>
                                    <div className="l--navElement" key={index} style={{ backgroundColor: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].backgroundColor }}>
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].title &&
                                        <h3 dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].title }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].teaser &&
                                        <p dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].teaser }} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].image &&
                                        <GatsbyImage image={getImage(props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].image.gatsbyImage)} alt={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].image.altText} />
                                      }
                                      {props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].link &&
                                        <a href={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].link.url} target={props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].link.target}>
                                          <span>{props.allWordpress.nodes[0].themeSettings.navigationElements.newNavigationCustomerStories[4].link.title}</span>
                                          <img src={rightIcon} alt="" />
                                        </a>
                                      }
                                    </div>
                                  </>
                                }
                              </>
                            }
                            {/* {activeElement === "elemid-0" && tertiaryActiveElement === "elemtertiaryid-2" ?
                              <div className="l--layoutTwo l--flex">
                                <div className="l--layoutTwo__image">
                                  <GatsbyImage image={getImage(props.allWordpress.nodes[0].themeSettings.navigationElements.subNavElement2Image.gatsbyImage)} alt={props.allWordpress.nodes[0].themeSettings.navigationElements.subNavElement2Image.altText} />
                                </div>
                                <div className="l--layoutTwo__content">
                                  <span className="l-headerTwo">{props.allWordpress.nodes[0].themeSettings.navigationElements.subNavElement2Title}</span>
                                  <p>{props.allWordpress.nodes[0].themeSettings.navigationElements.subNavElement2Teaser}</p>
                                  {props.allWordpress.nodes[0].themeSettings.navigationElements.subNav2DropdownLink &&
                                    <a href={props.allWordpress.nodes[0].themeSettings.navigationElements.subNav2DropdownLink.url} target={props.allWordpress.nodes[0].themeSettings.navigationElements.subNav2DropdownLink.target}><span>{props.allWordpress.nodes[0].themeSettings.navigationElements.subNav2DropdownLink.title}</span> <img src={rightIcon} alt="" /></a>
                                  }
                                </div>
                              </div>
                              :
                              <div className="l--layoutOne">
                                {activeElement === "elemid-32" ?
                                  <span className="l-headerThree">Resources</span>
                                  :
                                  <span className="l-headerThree" dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.subNav1Header }} />
                                }
                                {props.allWordpress.nodes[0].themeSettings.navigationElements.subNav1CustomerStories &&
                                  <>
                                    {props.allWordpress.nodes[0].themeSettings.navigationElements.subNav1CustomerStories.map((addnavStories, index) => (
                                      <>
                                        {activeElement === "elemid-0" && (index === 0 || index === 1) &&
                                          <a key={index} href={`/customer-stories/${addnavStories.slug}`} className="l--story l--flex">
                                            {addnavStories.featuredImage &&
                                              <GatsbyImage image={getImage(addnavStories.featuredImage.node.gatsbyImage)} alt={addnavStories.featuredImage.node.altText} />
                                            }
                                            <div className="l--story__content">
                                              <span className="l-headerTwo" dangerouslySetInnerHTML={{ __html: addnavStories.title }} />
                                              <div dangerouslySetInnerHTML={{ __html: addnavStories.excerpt.length > 80 ? addnavStories.excerpt.substring(0, 80) + "..." : addnavStories.excerpt }} />
                                            </div>
                                          </a>
                                        }
                                        {activeElement === "elemid-28" && (index === 2 || index === 3) &&
                                          <a key={index} href={`/customer-stories/${addnavStories.slug}`} className="l--story l--flex">
                                            {addnavStories.featuredImage &&
                                              <GatsbyImage image={getImage(addnavStories.featuredImage.node.gatsbyImage)} alt={addnavStories.featuredImage.node.altText} />
                                            }
                                            <div className="l--story__content">
                                              <span className="l-headerTwo" dangerouslySetInnerHTML={{ __html: addnavStories.title }} />
                                              <div dangerouslySetInnerHTML={{ __html: addnavStories.excerpt.length > 80 ? addnavStories.excerpt.substring(0, 80) + "..." : addnavStories.excerpt }} />
                                            </div>
                                          </a>
                                        }
                                        {activeElement === "elemid-32" && (index === 4 || index === 5) &&
                                          <a key={index} href={`${index === 4 ? "/resources/white-papers/" : "/resources/on-demand-webinars/"}${addnavStories.slug}`} className="l--story l--flex">
                                            {addnavStories.featuredImage &&
                                              <GatsbyImage image={getImage(addnavStories.featuredImage.node.gatsbyImage)} alt={addnavStories.featuredImage.node.altText} />
                                            }
                                            <div className="l--story__content">
                                              <span className="l-headerTwo" dangerouslySetInnerHTML={{ __html: addnavStories.title }} />
                                              {addnavStories.excerpt &&
                                                <div dangerouslySetInnerHTML={{ __html: addnavStories.excerpt.length > 40 ? addnavStories.excerpt.substring(0, 40) + "..." : addnavStories.excerpt }} />
                                              }
                                            </div>
                                          </a>
                                        }
                                        {activeElement === "elemid-39" && (index === 6 || index === 7) &&
                                          <a key={index} href={`/customer-stories/${addnavStories.slug}`} className="l--story l--flex">
                                            {addnavStories.featuredImage &&
                                              <GatsbyImage image={getImage(addnavStories.featuredImage.node.gatsbyImage)} alt={addnavStories.featuredImage.node.altText} />
                                            }
                                            <div className="l--story__content">
                                              <span className="l-headerTwo" dangerouslySetInnerHTML={{ __html: addnavStories.title }} />
                                              <div dangerouslySetInnerHTML={{ __html: addnavStories.excerpt.length > 80 ? addnavStories.excerpt.substring(0, 80) + "..." : addnavStories.excerpt }} />
                                            </div>
                                          </a>
                                        }
                                      </>
                                    ))}
                                  </>
                                }
                                {activeElement === "elemid-32" ?
                                  <a className="l-textlink" href="/resources/" target="_self"><span>All Resources</span> <img src={rightIcon} alt="" /></a>
                                  :
                                  <>
                                    {props.allWordpress.nodes[0].themeSettings.navigationElements.subNav1Link &&
                                      <a className="l-textlink" href={props.allWordpress.nodes[0].themeSettings.navigationElements.subNav1Link.url} target={props.allWordpress.nodes[0].themeSettings.navigationElements.subNav1Link.target}><span>{props.allWordpress.nodes[0].themeSettings.navigationElements.subNav1Link.title}</span> <img src={rightIcon} alt="" /></a>
                                    }
                                  </>
                                }
                              </div>
                            } */}
                          </div>
                        </div>
                      }
                    </li>
                  }
                </React.Fragment>
              ))}
            </ul>
            <LangSelector />
          </nav>
          <div className="l--flex l--flexCTA">
            <div className="l-relativeButton l--mobileOnlyCTA">
              {propss &&
                <>
                  <a className="l-button" href={propss.url}>{propss.title}</a>
                  <a className="l-button l-backgroundHover" href={propss.url}>{propss.title}</a>
                </>
              }
            </div>
            <button aria-label="Click icon to open navigation" className="cp-booktoggle__hamburger js-hamburger-toggle" onClick={() => hamburgerClick('hamburgerOpen')} aria-live="polite">
              <span className="visually-hidden l-nav"></span>
              <span className="cp-booktoggle__hamburger--icon js-hamburger-child">
                <span></span><span></span><span></span><span></span><span></span><span></span>
              </span>
            </button>
          </div>
          {/* {loader &&
            <div className="cp-loader l--absolute">
              <StaticImage src="../../images/ajax_loader.gif" alt="" />
            </div>
          } */}
        </>
      )} />
  );
};

export default MainMenu